import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { SelectedWork } from './components/SelectedWork';
import { About } from './components/About';
import { Writing } from './components/Writing';
import { Newsletter } from './components/Newsletter';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { GoogleTagManager } from './components/GoogleTagManager';
import analytics from './utils/analytics';
export function App() {
  const controls = useAnimation();
  useEffect(() => {
    controls.start({
      opacity: 1
    });
    // Initialize analytics
    analytics.page();
  }, [controls]);
  return <>
      {/* Add Google Tag Manager with your GTM ID */}
      <GoogleTagManager gtmId="GTM-5ZK3BV2J" data-id="element-0" />
      <motion.div className="flex flex-col min-h-screen overflow-x-hidden" style={{
      backgroundColor: '#F4F6ED'
    }} initial={{
      opacity: 0
    }} animate={controls} transition={{
      duration: 0.5
    }} data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Hero data-id="element-4" />
          <Services data-id="element-5" />
          <SelectedWork data-id="element-6" />
          <About data-id="element-7" />
          <Writing data-id="element-8" />
          <Newsletter data-id="element-9" />
          <Contact data-id="element-10" />
        </main>
        <Footer data-id="element-11" />
      </motion.div>
    </>;
}